import { Suspense, useContext, useState } from "react";
import { OperationContext } from "../CreateOperation";
import { Button, Empty, InputNumber } from "antd";
import { TitleBadge } from "../components/TitleBadge";
import { HoldContainer } from "./components/HoldContainer";
import style from "./style.module.scss";
import { CustomDrawer } from "../../../../../common/components/Drawer/CustomDrawer";
import { HoldForm } from "./components/HoldForm";
import { Loader } from "../../../../../common/components/Loader/Loader";
import CustomModal from "../../../../../common/components/Modal/CustomModal";
import { LuGrid2X2Plus } from "react-icons/lu";

export const Hold = () => {
  const { initialValue, refreshData } = useContext(OperationContext);
  const hasBag = initialValue?.loadsTxt.toLowerCase().includes("sac");
  const hasContainer = initialValue?.loadsTxt.toLowerCase().includes("conteneur");
  // const merchandise = initialValue?.loadsTxt;
  const debarkationDistributions =
  initialValue?.debarkationMovement?.holdDistributions ?? [];

  const embarkationDistributions =
    initialValue?.embarkationMovement?.holdDistributions ?? [];

  const hasDebarkation = !!initialValue?.debarkationMovement;
  const hasEmbarkation = !!initialValue?.embarkationMovement;

  const isDebarkationEmpty =
    hasDebarkation && debarkationDistributions.length === 0;

  const isEmbarkationEmpty =
    hasEmbarkation && embarkationDistributions.length === 0;

  const shouldShowDistributionButton =
    isDebarkationEmpty || isEmbarkationEmpty;

  const movements =
    isDebarkationEmpty && isEmbarkationEmpty
      ? "both"
      : isDebarkationEmpty
        ? "debarkation"
        : "embarkation";

  const holdContainerDebarkationValue = {
    movementName: "Débarquement",
    holdDistributions: initialValue?.debarkationMovement?.holdDistributions,
  };
  const holdContainerEmbarkationValue = {
    movementName: "Embarquement",
    holdDistributions: initialValue?.embarkationMovement?.holdDistributions,
  };

  //const holds = initialValue?.holds;
  const [holdNumber, setHoldNumber] = useState<number | null>(null);

  const [isShowForm, setIsShowForm] = useState<boolean>(false);
  // const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isShowModal, setIsShowModal] = useState<boolean>(false);

  const generatedHolds = holdNumber
  ? Array.from({ length: holdNumber }, (_, index) => index + 1)
  : [];

  const onShowAddHandler = () => {
    setIsShowModal(false);
    setIsShowForm((prev) => !prev);
  };

  const onShowHoldNumberModal = () => {
    if (
      (hasDebarkation && isDebarkationEmpty && hasEmbarkation && !isEmbarkationEmpty) ||
      (hasEmbarkation && isEmbarkationEmpty && hasDebarkation && !isDebarkationEmpty)
    ) {
      setHoldNumber(initialValue?.holdsValueLength ?? null);
      setIsShowForm(true);
      return;
    }
  
    setIsShowModal((prev) => !prev);
  };

  const MANIFESTO_ALL_TYPE = [
    initialValue?.debarkationMovement?.id && {
      value: initialValue?.debarkationMovement?.id,
    },
    ,
    initialValue?.embarkationMovement?.id && {
      value: initialValue?.embarkationMovement?.id,
    },
    ,
  ]?.filter((item) => item);

  const isWaitingManifesto = !(!!MANIFESTO_ALL_TYPE.length);

  const onFinishAction = () => {
    refreshData();
    onShowAddHandler();
  };

  const hasAnyDistribution =
  debarkationDistributions.length > 0 ||
  embarkationDistributions.length > 0;

  return (
    <div>
      <div className={style.main}>
      {!isWaitingManifesto && hasAnyDistribution && (
        <TitleBadge 
          label="Nombre de cale" 
          value={initialValue?.holdsValueLength} 
        />
      )}

      {shouldShowDistributionButton && (
        <Button
          className={`d-flex gap-2 ${style.main__button}`}
          onClick={onShowHoldNumberModal}
        >
          <LuGrid2X2Plus size={15} />
          Répartir la marchandise
        </Button>
      )}
      </div>
        <div>
          {!isWaitingManifesto ? (
            <>
              {debarkationDistributions.length > 0 && (
                <HoldContainer
                  hasBag={hasBag}
                  hasContainer={hasContainer}
                  value={holdContainerDebarkationValue}
                />
              )}

              {embarkationDistributions.length > 0 && (
                <HoldContainer
                  hasBag={hasBag}
                  hasContainer={hasContainer}
                  value={holdContainerEmbarkationValue}
                />
              )}

              {debarkationDistributions.length === 0 &&
                embarkationDistributions.length === 0 && (
                  <div className={style.main__empty}>
                    <Empty
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                      description="En attente de répartition"
                    />
                  </div>
                )}
            </>
          ) : (
            <Empty description="En attente de manifeste" />
          )}
        </div>
      {/* <div className="">{activeComponent}</div> */}
      <Suspense fallback={<Loader isLoading />}>
        <CustomDrawer
          isOpen={isShowForm}
          onClose={onShowAddHandler}
          title={"Répartition de la marchandise par cale"}
          width={"75%"}
        >
          <HoldForm
            operationId={initialValue?.id}
            onFinish={onFinishAction}
            movements={movements}
            hasBag={hasBag}
            hasContainer={hasContainer}
            holds={generatedHolds}
          />
        </CustomDrawer>
      </Suspense>
      
      <CustomModal
        isOpen={isShowModal}
        hanldeCloseModal={onShowHoldNumberModal}
      >
        <div className={style.modal__element}>
          <span>Nombre de cales :</span>

          <InputNumber
            min={1}
            precision={0}
            step={1}
            placeholder="Nombre de cales"
            value={holdNumber}
            onChange={(value) => {
              setHoldNumber(value);
            }}
          />

          <Button
            className={style.modal__element__button}
            onClick={onShowAddHandler}
            disabled={!holdNumber || holdNumber < 1}
          >
            Continuer
          </Button>
        </div>
      </CustomModal>
    </div>
  );
};
